<template>
  <div class="enter-phone-number-modal relative">
    <BasePreloader v-if="loading" />

    <button
      class="enter-phone-number-modal__close"
      @click.prevent="close"
    >
      <BaseSvg name="ico-close" width="1.6rem" height="1.6rem" />
    </button>

    <div class="d-flex justify-center">
      <img
        src="@/assets/img/circles-check.webp"
        alt="message"
        style="object-fit: cover"
        class="modal-successfully-sent__img"
      >
    </div>

    <h3 class="popup-full__title">{{ title || $tAuth('title-for-respond') }}</h3>
    <div class="popup-full__text text">
      <p>{{ subtitle || $tAuth('subtitle-for-respond') }}</p>
    </div>

    <BaseInput
      v-model="form.name"
      :label="$tVacancy('Name')"
    />

    <BaseInputPhone
      v-model="form.phone"
      :label="$tVacancy('Phone number')"
      class="mt-5"
      @validate="onValidatePhone"
    />

    <div class="d-flex mt-5">
      <div class="mr-2">
        <div class="enter-phone-number-modal__conditions-alert">i</div>
      </div>
      <div>
        <span>{{ $tVacancy('By clicking on the button you agree') }}&nbsp;</span>
        <router-link-modified
          class="enter-phone-number-modal__conditions-condition-link base-link"
          target="_blank"
          :to="{ name: 'terms-of-use' }"
        >
          {{ $tVacancy('of user agreement') }}
        </router-link-modified>
      </div>
    </div>

    <BaseAlert :value="errors" class="_error mt-4" />

    <button
      class="base-btn base-btn--blue mt-5"
      :disabled="!submitBtnAvailable"
      @click="submit"
    >
      {{ submitBtnText || $tVacancy('Submit') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EnterPhoneNumberModal',
  props: {
    modalName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    submitBtnText: {
      type: String,
      default: null,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
      },
      errors: [],
      phoneValidation: null,
      loading: false,
    };
  },
  computed: {
    submitBtnAvailable() {
      return this.phoneValidation?.isValid;
    },
  },
  created() {
    this.$eventBus.$on('enter-phone-number-modal-errors', this.setErrors);
  },
  beforeDestroy() {
    this.$eventBus.$off('enter-phone-number-modal-errors', this.setErrors);
  },
  methods: {
    submit() {
      this.loading = true;
      const dataOrPromise = this.onSubmit({ ...this.form });
      if (dataOrPromise instanceof Promise) {
        dataOrPromise.finally(() => this.loading = false);
      } else this.loading = false;
    },
    setErrors(errors) {
      this.errors = errors;
    },
    onValidatePhone(validation) {
      this.phoneValidation = validation;
    },
    close() {
      this.$vModal.close(this.modalName);
    },
  },
};
</script>
